package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.model.MemberRole
import fr.manyverse.app.domain.repository.GameTableRepository

class JoinGameTableUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(
        code: String,
        userId: String,
        characterId: String? = null
    ): Result<GameTable> {
        val tableResult = gameTableRepository.findTableByCode(code)

        return tableResult.fold(
            onSuccess = { table ->
                if (table == null) {
                    Result.failure(ValidationError("Invalid table code"))
                } else {
                    val userTablesResult = gameTableRepository.getAllUserActiveTables(userId)
                    userTablesResult.fold(
                        onSuccess = { userTables ->
                            val isAlreadyMember = userTables.any { (userTable, _) ->
                                userTable.id == table.id
                            }
                            if (isAlreadyMember) {
                                Result.success(table)
                            } else {
                                gameTableRepository.joinTable(
                                    tableId = table.id,
                                    userId = userId,
                                    characterId = characterId,
                                    role = if (userId == table.gameMasterId) {
                                        MemberRole.GAME_MASTER
                                    } else {
                                        MemberRole.PLAYER
                                    }
                                ).map { table }
                            }
                        },
                        onFailure = { Result.failure(it) }
                    )
                }
            },
            onFailure = { Result.failure(it) }
        )
    }
}
